<template>
  <div class="container whole">
    <div class="grid">
      <div class="gradient">
        <h1>
          What our Trainers <br />
          are Saying!
        </h1>
      </div>
      <div id="center">
        <tiny-slider
          :mouse-drag="true"
          :loop="true"
          items="1"
          navPosition="bottom"
          gutter="20"
          controlsPosition="bottom"
          speed="2000"
          :autoplay="true"
          :arrow-keys="true"
          :navAsThumbnails="true"
          :responsive="{}"
        >
          <div class="slide">
            <div class="flex1">
              <img
                :src="items[0].image"
                alt=""
                style="width:125px; height:125px; border-radius:50%;"
              />

              <div class="right">
                <h2>
                  {{ items[0].title }}
                </h2>
                <h3>
                  {{ items[0].subtitle }}
                </h3>
              </div>
            </div>

            <p>
              {{ items[0].body }}
            </p>
          </div>
          <div class="slide">
            <div class="flex1">
              <img
                :src="items[1].image"
                alt=""
                style="width:125px; height:125px; border-radius:50%;"
              />

              <div class="right">
                <h2>
                  {{ items[1].title }}
                </h2>
                <h3>
                  {{ items[1].subtitle }}
                </h3>
              </div>
            </div>

            <p>
              {{ items[1].body }}
            </p>
          </div>
          <div class="slide">
            <div class="flex1">
              <img
                :src="items[2].image"
                alt=""
                style="width:125px; height:125px; border-radius:50%;"
              />

              <div class="right">
                <h2>
                  {{ items[2].title }}
                </h2>
                <h3>
                  {{ items[2].subtitle }}
                </h3>
              </div>
            </div>

            <p>
              {{ items[2].body }}
            </p>
          </div>
        </tiny-slider>
      </div>
    </div>
  </div>
</template>

<script>
// import UTestimonialSlider from '../core/UTestimonialSlider.vue';
import VueTinySlider from 'vue-tiny-slider'
export default {
  data() {
    return {
      items: [
        {
          title: 'Saqiful Alam',
          subtitle: 'Analytics Advisor, Intelligent Machines Limited',
          body:
            'The feedback and advice from the Upskill team when designing the curriculum have contributed to create some really top-class training sessions.',
          image: require('../../assets/saquif.jpg'),
        },
        {
          title: 'Mahmud Khairul Rahman',
          subtitle: 'Senior Designer,ROI Machines',
          body:
            'Being a trainer for the UI/UX Design workshop was a great experience in this challenging time. This was without doubt one of the best batches I have taught throughout my career. The Upskill team was a great support during the sessions. I love their goal of bringing quality education to one platform. This platform was needed for a very long time and now we all need to make the best use of it.',
          image: require('../../assets/khairul.jpg'),
        },
        {
          title: 'Ishraq Dhaly',
          subtitle: 'Director, Accounts & Servicing, Magnito Digital',
          body:
            'Upskill has built a knowledge-centric platform, they package it the proper way, and they present it in the best way!',

          image: require('../../assets/dhaly.gif'),
        },
      ],
    }
  },

  components: {
    'tiny-slider': VueTinySlider,
  },
}
</script>

<style scoped>
.whole {
  padding: 0 25px;
  padding-bottom: 100px;
}
#center {
  background-color: #fff;
  max-width: 650px;
  border-radius: 0 10px 10px 0;
}
.slide {
  padding: 0px;
}
.flex1 {
  display: flex;
  align-items: center;
  margin-top: 50px;
  margin-left: 50px;
}
.right {
  padding-left: 35px;
}
.right h2 {
  font-family: 'Open Sans';
  font-weight: 700;
  font-size: 24px;
  letter-spacing: -1.2px;
  color: #000000;
  text-transform: capitalize;
  opacity: 1;
}
.right h3 {
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 18px;

  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}
p {
  margin: 10px 50px;
  padding-top: 50px;
  text-align: left;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0px;
  color: #728391;
  opacity: 1;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-height: 500px;
  max-width: 1300px;
  margin: 0 auto;
}
.gradient {
  background: transparent linear-gradient(180deg, #cc38ef 0%, #501199 100%) 0%
    0% no-repeat padding-box;
  border-radius: 10px 0 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gradient h1 {
  font-family: 'Montserrat';
  font-size: 32px;
  font-weight: 700;
  text-align: left;

  letter-spacing: -0.8px;
  color: #ffffff;
  opacity: 1;
}

@media only screen and (max-width: 600px) {
  .grid {
    display: grid;
    grid-template-columns: 1fr;
  }
  .whole {
    padding: 0 0px;
    padding-bottom: 0px;
  }

  .flex1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    margin-left: 0px;
    margin-right: 80px;
  }
  .right {
    padding-left: 0;
    margin-top: 15px;
    margin-left: 50px;
    display: flex;
    flex-direction: column;
  }
  #center {
    margin: 0 auto;
    background-color: #fff;
    max-width: 350px;
    width: 100%;
  }
  .tns-controls button {
    display: none !important;
  }
  .gradient {
    min-height: 350px;
  }
}
</style>
